import { useState, useEffect } from "react";

import {
  Drawer,
  Box,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Divider,
  TextField,
  Chip
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import { Autocomplete } from "@mui/material";
import ORDER_ROW_TYPE_META from "./helpers/types";
import { useLazyQuery } from "@apollo/client";
import { GET_ORDERING_COMPANIES } from "../../graphql/queries/IncomingOrdersContext";
import ORDER_STATUSES from "./helpers/orderCategories";

const drawerWidth = 360;


const useDebouncedValue = (value, delay = 400) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};


const IncomingOrdersFilterPanel = ({
  open,
  onClose,
  supplierOrderStatuses = [],  
  filters,
  onApply,
  onReset
}) => {

  const [localFilters, setLocalFilters] = useState(filters);

  const [searchOrdererCompany] = useLazyQuery(GET_ORDERING_COMPANIES);

  const [companyOptions, setCompanyOptions] = useState([]);
  const [companyLoading, setCompanyLoading] = useState(false);

  const [companySearch, setCompanySearch] = useState("");
  const debouncedCompanySearch = useDebouncedValue(companySearch, 400);


  useEffect(() => {
    if (!open) return;

    setCompanyLoading(true);

    searchOrdererCompany({
      variables: { searchTerm: "" }
    })
      .then(({ data }) => {
        const companies =
          data?.incomingOrdersContext?.searchOrderingCompany ?? [];

        setCompanyOptions(companies);
      })
      .finally(() => {
        setCompanyLoading(false);
      });

  }, [open]);

  const selectedCompany =
    companyOptions.find(
      c => c.companyId === localFilters?.orderingCompanyIds
    ) ??
    (localFilters?.orderingCompanyIds
      ? {
        companyId: localFilters.orderingCompanyId,
        name: "Vald kund"
      }
      : null);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const update = (key, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const toggleType = (type) => {
    const types = localFilters.productTypes || [];

    if (types.includes(type)) {
      update(
        "productTypes",
        types.filter(t => t !== type)
      );
    } else {
      update(
        "productTypes",
        [...types, type]
      );
    }
  };

  const toggleSupplierStatus = (statusId) => {
    const statuses = localFilters.supplierOrderStatusIds || [];

    if (statuses.includes(statusId)) {
      update(
        "supplierOrderStatusIds",
        statuses.filter((s) => s !== statusId)
      );
    } else {
      update(
        "supplierOrderStatusIds",
        [...statuses, statusId]
      );
    }
  };

  const handleApply = () => {
    onApply(localFilters);
    onClose();
  };

  const handleReset = () => {

    const empty = {
      supplierOrderStatusIds: [],
      orderStatus: null,
      orderingCompanyIds: [],
      productTypes: [],
      fromDate: null,
      toDate: null,
      deliveryDateFrom: null,
      deliveryDateTo: null
    };

    setCompanySearch("");
    setCompanyOptions([]);

    setLocalFilters(empty);
    onReset(empty);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Box
        sx={{
          width: drawerWidth,
          p: 3,
          display: "flex",
          flexDirection: "column",
          height: "100%"
        }}
      >

        <Typography variant="h6" sx={{ mb: 2 }}>
          Filter
        </Typography>

        <Stack spacing={3}>
          {/* Kund 
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Kund
  </Typography>

            <Autocomplete
              size="small"
              options={companyOptions}
              loading={companyLoading}
              filterOptions={(options, state) =>
                options.filter(o =>
                  (o.name ?? "")
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase())
                )
              }
              value={companyOptions.filter(c =>
                localFilters?.orderCompanyIds?.includes(c.companyId)
              )}
              onChange={(e, values) => {

                

                update(
                  "orderCompanyIds",
                  values.map(v => v.companyId)
                );

              }
                
              }
              getOptionLabel={(option) => option?.name ?? ""}
              isOptionEqualToValue={(option, value) =>
                option.companyId === value.companyId
              }
              renderTags={() => null} // hide default MUI chips
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Kund"
                  placeholder="Sök kund..."
                />
              )}
            />

            
            <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 1 }}>
              {(localFilters?.orderCompanyIds ?? []).map((companyId) => {
                const company = companyOptions.find(
                  c => c.companyId === companyId
                );

                if (!company) return null;

                return (
                  <Chip
                    key={company.companyId}
                    label={company.name}
                    onDelete={() =>
                      update(
                        "orderCompanyIds",
                        localFilters.orderCompanyIds.filter(
                          id => id !== company.companyId
                        )
                      )
                    }
                  />
                );
              })}
            </Stack>
          </Box>
        
          <Divider/>*/}

          {/* Leverantörsstatus */}
          <Box>
            <Typography
              variant="subtitle2"
              sx={{ mb: 1 }}
            >
              Status
            </Typography>
            <Stack spacing={3} direction="column">
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1 }}
                >
                  Leverantörsstatus
  </Typography>

                <Stack direction="row" flexWrap="wrap" gap={1}>
                  {supplierOrderStatuses.map((status) => {
                    const selected =
                      localFilters?.supplierOrderStatusIds?.includes(status.id);

                    return (
                      <Chip
                        key={status.id}
                        label={status.name}
                        color={selected ? "primary" : "default"}
                        onClick={() => toggleSupplierStatus(status.id)}
                      />
                    );
                  })}
                </Stack>
              </Box>

          {/* Orderstatus */}
          <FormControl size="small" fullWidth>
            <InputLabel>Orderstatus</InputLabel>

                <Select
                  value={localFilters?.orderStatus ?? null}
                  label="Orderstatus"
                  onChange={(e) =>
                    update("orderStatus", e.target.value || null)
                  }
                >
                  <MenuItem value="">
                    Alla
                  </MenuItem>

                  {ORDER_STATUSES.map((status) => (
                    <MenuItem key={status.key} value={status.key}>
                      {status.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Box>
          <Divider />

          {/* Typer */}
          <Box>
            <Typography
              variant="subtitle2"
              sx={{ mb: 1 }}
            >
              Typer
            </Typography>

            <Stack
              direction="row"
              flexWrap="wrap"
              gap={1}
            >
              {Object.entries(ORDER_ROW_TYPE_META).map(([key, type]) => {

                const selected =
                  localFilters?.productTypes?.includes(key);

                return (
                  <Chip
                    key={key}
                    label={`${type.icon} ${type.label}`}
                    color={selected ? "primary" : "default"}
                    onClick={() => toggleType(key)}
                  />
                );
              })}
            </Stack>
          </Box>

          <Divider />

          {/* Orderdatum */}
          <Box>

            <Typography
              variant="subtitle2"
              sx={{ mb: 1 }}
            >
              Orderdatum
            </Typography>

            <Stack direction="row" spacing={2}>

              <DatePicker
                label="Från"
                value={localFilters?.fromDate}
                onChange={(value) =>
                  update("fromDate", value)
                }
                slotProps={{
                  textField: { size: "small", fullWidth: true }
                }}
              />

              <DatePicker
                label="Till"
                value={localFilters?.toDate}
                onChange={(value) =>
                  update("toDate", value)
                }
                slotProps={{
                  textField: { size: "small", fullWidth: true }
                }}
              />

            </Stack>
          </Box>

          <Divider />

          {/* Leveransdatum */}
          <Box>

            <Typography
              variant="subtitle2"
              sx={{ mb: 1 }}
            >
              Önskat leveransdatum
            </Typography>

            <Stack direction="row" spacing={2}>

              <DatePicker
                label="Från"
                value={localFilters?.deliveryDateFrom}
                onChange={(value) =>
                  update("deliveryDateFrom", value)
                }
                slotProps={{
                  textField: { size: "small", fullWidth: true }
                }}
              />

              <DatePicker
                label="Till"
                value={localFilters?.deliveryDateTo}
                onChange={(value) =>
                  update("deliveryDateTo", value)
                }
                slotProps={{
                  textField: { size: "small", fullWidth: true }
                }}
              />

            </Stack>

          </Box>

        </Stack>

        {/* Bottom buttons */}
        <Box
          sx={{
            mt: "auto",
            pt: 3
          }}
        >

          <Stack direction="row" spacing={2}>

            <Button
              fullWidth
              variant="outlined"
              onClick={handleReset}
            >
              Rensa
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={handleApply}
            >
              Applicera
            </Button>

          </Stack>

        </Box>

      </Box>
    </Drawer>
  );
};

export default IncomingOrdersFilterPanel;